import { connect } from 'react-redux';
import type { ConnectedProps } from 'react-redux';

import {
  getIsShowSubscription,
  searchTypeSelector,
} from 'src/store/view/selectors';
import {
  getHotelsCount,
  getHasHotels,
  getFallbackSearch,
  getNearestDepartures,
  getNearestDates,
} from '../../domain/state/hotels/selectors';
import { isMapView, popupDataSelector } from '../../domain/state/map/selectors';
import {
  modifierBannerSelector,
  modifierStylesSelector,
} from '../../domain/state/modifier/selectors';
import {
  getIsMetaregion,
  getIsSubscribeShown,
  isFiltersHidden,
} from '../../domain/state/view/selectors';

import { MainContainer } from './MainContainer';

const mapStateToProps = (state) => ({
  mapExpanded: isMapView(state),

  // нужен для скрытия floatingPanelMobile при открытой карточке отеля на карте, стилями перекрыть не получается
  isOpenedMapPopup: !!popupDataSelector(state),
  hotelCounter: getHotelsCount(state),
  hasHotels: getHasHotels(state),
  fallbackSearch: getFallbackSearch(state),
  nearestDeparturesData: getNearestDepartures(state),
  nearestDatesData: getNearestDates(state),
  modifierBanner: modifierBannerSelector(state),
  modifierStyles: modifierStylesSelector(state),
  searchType: searchTypeSelector(state),
  isMetaregion: getIsMetaregion(state),
  allowShowSubscription: getIsShowSubscription(state),
  hideFilters: isFiltersHidden(state),
  isSubscribeShown: getIsSubscribeShown(state),
});

const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(MainContainer);
